import { CameraDeviceInfo } from "@videosdk.live/react-sdk";
import {
  Button, Col, Flex, Popover, Row, Space, Typography
} from "antd";
import { VideoCameraOutlined, CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import useVideoStore from "../../hooks/useVideoStore";

const { Text } = Typography;

const CamControls = ({
  webcams,
  changeWebcam
} : {
  webcams: CameraDeviceInfo[],
  changeWebcam: (deviceId: string) => void
}) => {
  const { t } = useTranslation();
  const {
    setSelectedWebcam,
    selectedWebcam,
    isCameraPermissionAllowed
  } = useVideoStore();

  return (
    <Popover
      content={(
        <Space direction="vertical" size={0}>
          {webcams.map(
            (item, index) => {
              return item?.kind === "videoinput" && (
                <Button
                  key={item.deviceId}
                  type="text"
                  onClick={() => {
                    setSelectedWebcam({ id: item?.deviceId, label: item?.label });
                    changeWebcam(item?.deviceId);
                  }}
                  block
                >
                  <Row gutter={8} style={{ width: "100%" }}>
                    <Col span={2}>
                      {selectedWebcam?.label === item?.label && (
                        <CheckOutlined/>
                      )}
                    </Col>
                    <Col span={22} style={{ textAlign: "left" }}>
                      <Text ellipsis>
                        {item?.label ? item?.label : `Webcam ${index + 1}`}
                      </Text>
                    </Col>
                  </Row>
                </Button>
              );
            }
          )}
        </Space>
      )}
      trigger="click"
      placement="topLeft"
    >
      <Button
        disabled={!isCameraPermissionAllowed}
        block
      >
        <Flex gap={10} style={{ width: "100%", color: "black", opacity: ".25" }}>
          <VideoCameraOutlined />
          <Text ellipsis>
            {isCameraPermissionAllowed ? selectedWebcam?.label : t("video.permissionNeeded")}
          </Text>
        </Flex>
      </Button>
    </Popover>
  );
};

export default CamControls;
